module.exports = require('@feathersjs/authentication-client');
